export const SIDEBAR_WIDTH = 420;
